<template>
  <div id="confirmOrder" @click='doNothing'>
   <div class="infoWrap">
     <div class="infoTitle">顾客信息</div>
     <div class="userInfoWrap" @click='changeMobile'>
       <img :src="userInfo.avatar">
       <div class="userInfo">
         <div class="nickname">{{userInfo.realName||userInfo.nickName||'喜盈门会员'}}</div>
         <div class="mobile">{{userInfo.mobile}}</div>
       </div>
     </div>
   </div>
   <div class="proInfo" v-if='couponInfo'>
     <div class="title">商品</div>
     <div class="proItem">
       <div class="proImg">
         <img :src="couponInfo.couponCover">
       </div>
       <div class="proDesc">
         <div class="proName">{{couponInfo.couponName}}</div>
         <div class="proPriceWrap">
           <div class="price"><span>¥ </span>{{filterPrice(couponInfo.price,1)}}<span>.{{filterPrice(couponInfo.price)}}</span></div>
           <div class="stepWrap">
             <div :class="{lessBtn:true,disabled:proNum<=1}" @click='changeNum("del")'>
               <img :src="picUrl.cut">
             </div>
             <div class="proNum">{{proNum}}</div>
             <div :class="{addBtn:true,disabled:showWaring || proNum==max}" @click='changeNum("add")'>
               <img :src="picUrl.add">
             </div>
           </div>
         </div>
       </div>
     </div>
   </div>
   <div class="waring" v-if='showWaring'>
     <img :src="picUrl.icon_warn"><span>已达到最高购买数量</span>
   </div>
   <div class="bzWrap">
     <span>订单备注</span>
     <textarea placeholder="选填，请先和商家协商一致(50字以内)" v-model='orderRemark' @blur='blurInput'></textarea>
   </div>
   <div class="fixedBtn">
      <span class="totalText">合计：</span>
      <div class="price">
        <span>¥ </span>{{filterPrice(totalPrice,1)}}<span>.{{filterPrice(totalPrice)}}</span>
      </div>
      <div class="payBtn" @click='submit'>去支付</div>
    </div>
  </div>
</template>
<script>
import { buriedPoint } from '@/utils/utils.js'
import { floatMul } from '@/utils/index.js'
export default {
  name: 'confirmOrder',
  data () {
    return {
      picUrl: {
        icon_back: this.$store.state.ossLink + 'live/icon_back.png',
        icon_warn: this.$store.state.ossLink + 'live/icon_warn@2x.png',
        add: this.$store.state.ossLink + 'live/add@2x.png',
        cut: this.$store.state.ossLink + 'live/cut@2x.png'
      },
      userInfo: '',
      couponInfo: '',
      proNum: 1,
      showWaring: false,
      orderRemark: '',
      max: 9999
    }
  },
  computed: {
    totalPrice () {
      if (this.couponInfo.price) {
        return floatMul(this.couponInfo.price, this.proNum)
      }
    }
  },
  methods: {
    changeMobile () {
      let locationHref = window.location.href
      localStorage.removeItem('IS_CIMEN_STAR_USER')
      buriedPoint('CHANGE_MOBILE', this.studioCode)
      this.$router.push({path: '/login', query: {fromurl: locationHref, studioCode: this.studioCode}})
    },
    // 获取优惠券详情
    getDetail (studioCode, couponCode) {
      let self = this
      self.$fly
        .request({
          method: 'get',
          url: ' /star/live/manage/query/live/studio/coupon/info',
          params: {
            studioCode: studioCode,
            couponCode: couponCode
          }
        })
        .then(res => {
          if (res.success) {
            this.couponInfo = res.data
            // 如果库存不足或者限购了，显示0
            if (this.couponInfo.participateNum === 0 || this.couponInfo.surplusStock === 0) {
              this.proNum = 0
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    filterPrice (price, type) {
      let newPrice = price + ''
      if (!price) {
        return '00'
      } else {
        if (type === 1) {
          return newPrice.split('.')[0] || '00'
        } else {
          return newPrice.split('.')[1] || '00'
        }
      }
    },
    changeNum (type) {
      if (type === 'del') {
        if (this.couponInfo.participateNum === 0 || this.couponInfo.surplusStock === 0) {
          this.proNum = 0
        } else {
          let num = this.proNum - 1
          num <= 1 ? this.proNum = 1 : this.proNum = num
        }
        this.showWaring = false
      }
      if (type === 'add') {
        let num = this.proNum + 1
        let max = this.couponInfo.participateNum >= 0 ? Math.min(this.couponInfo.participateNum, this.couponInfo.surplusStock) : this.couponInfo.surplusStock
        this.max = max
        if (num >= max) {
          this.proNum = max
          this.showWaring = true
        } else {
          this.proNum = num
        }
      }
    },
    getOpenId () {
      let self = this
      self.$fly
        .request({
          method: 'post',
          url: '/h5/star/alliance2/star/guest/account/total/obtain/my/account'
        })
        .then(res => {
          if (res.success) {
            this.userInfo = res.data
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    wxShare () {
      let self = this
      self.$fly
        .request({
          url: '/component/wechat/login/get/js/config/stat',
          params: {
            url: location.href.split('#')[0]
          }
        })
        .then(res => {
          if (res.success) {
            self.$wx.config({
              debug: false,
              appId: res.data.appId,
              timestamp: res.data.timestamp,
              nonceStr: res.data.nonceStr,
              signature: res.data.signature,
              jsApiList: [
                'hideAllNonBaseMenuItem',
                'showAllNonBaseMenuItem'
              ]
            })
            self.$wx.ready(function () {
              // 隐藏分享
              self.$wx.hideAllNonBaseMenuItem()
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    /* eslint-disable */
    submit () { // 提交
      let self = this
      if (self.orderRemark.length > 50) { // 校验必填项
        return self.$weui.toast('订单备注不能超过50个字', {
          duration: 2000,
          className: 'weui-toast-center'
        })
      }
      if (self.proNum <= 0) { // 校验必填项
        return self.$weui.toast('购买数量不能小于一个', {
          duration: 2000,
          className: 'weui-toast-center'
        })
      }
      self.$fly
        .request({
          method: 'post',
          url: '/star/live/manage/order/buy/pay',
          body: {
            couponCode: self.couponInfo.couponCode,
            orderRemark: self.orderRemark,
            quantity: self.proNum,
            studioCode: self.studioCode,
            saleOrgType: localStorage.getItem('saleOrgType'),
            saleOrgNo: localStorage.getItem('saleOrgNo'),
            popularizeNo: self.popularizeNo
          }
        })
        .then(res => {
          if (res.success) {
            WeixinJSBridge.invoke(
            'getBrandWCPayRequest', {
              "appId": res.data.appId,     //公众号名称，由商户传入
              "timeStamp": res.data.timeStamp,         //时间戳，自1970年以来的秒数
              "nonceStr": res.data.nonceStr, //随机串
              "package": res.data.appletPackage,
              "signType": "MD5",         //微信签名方式：
              "paySign": res.data.paySign //微信签名
            },
            function (res) {
              console.log(res)
              if (res.err_msg == "get_brand_wcpay_request:ok") {
                localStorage.setItem('IS_PAY','USER_HAS_PAY')
                window.location.href = self.$store.state.ssoUrl + '/toPaySuccess.html'
                /* 支付成功同步数据
                 * /h5/star/task/enroll/handler/pay/success/sync
                 */
                // $.ajax({
                //   type: "GET",
                //   contentType: "application/json;charset=UTF-8",
                //   headers:{
                //     'tk': WaysTools.getQueryString('tk')
                //   },
                //   url: linkUrl + '/h5/star/task/enroll/handler/pay/success/sync',
                //   data: {
                //     queryTicket: result.data.queryTicket
                //   },
                //   success: function (result) {
                //     window.location.replace('toPaySuccess.html?type=' + type)
                //   },
                //   //请求失败，包含具体的错误信息
                //   error: function (e) {
                //     console.log(e.status);
                //     console.log(e.responseText);
                //   }
                // })

                // 使用以上方式判断前端返回,微信团队郑重提示：
                //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
              } else {
                alert("支付失败")
                // window.history.back()
              }
            });
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    blurInput () {
      window.scroll(0, 0);
    },
    doNothing () {}
  },
  activated () {
    this.studioCode = this.$route.query.studioCode
    this.couponCode = this.$route.query.couponCode
    this.popularizeNo = this.$route.query.popularizeNo
    console.log(this)
    this.getOpenId()
    this.getDetail(this.studioCode, this.couponCode)
    this.wxShare()
    this.proNum = 1
  },
  mounted () { }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  #confirmOrder{
    min-height: 100vh;
    background-color:#fff
  }
  .infoWrap{
    padding: 28px 24px 0px 24px;
    box-sizing: border-box;
    margin-bottom: 28px;
    .infoTitle{
      font-size: 32px;
      font-weight: 400;
      color: #333333;
      line-height: 44px;
      margin-bottom: 16px;
    }
    .userInfoWrap{
      align-items: center;
      display: flex;
      padding: 0 0px 32px 4px;
      border-bottom:2px solid #f6f6f6;
      img{
        width: 70px;
        height: 70px;
        border-radius: 50%;
        margin-right: 16px;
        flex-shrink: 0;
      }
      .userInfo{
        width: 610px;
        background-repeat:no-repeat;
        background-size: 18px 28px;
        background-image: url('https://xym-wechat.oss-cn-hangzhou.aliyuncs.com/spread/live/icon_back.png');
        background-position:right center;
        .nickname{
          font-size: 28px;
          font-weight: 400;
          text-align: left;
          color: #333333;
          line-height: 40px;
          margin-bottom: 2px;
        }
        .mobile{
          font-size: 26px;
          font-weight: 400;
          text-align: left;
          color: #333333;
          line-height: 36px;
        }
      }
    }
  }
  .proInfo{
    padding:0 24px 0 28px;
    .title{
      font-size: 32px;
      line-height: 44px;
      color: #333;
      margin-bottom: 16px;
    }
    .proItem{
      display: flex;
      align-items:center;
      margin-bottom: 20px;
      .proImg{
        width: 180px;
        height: 120px;
        border-radius:8px;
        overflow: hidden;
        flex-shrink: 0;
        margin-right: 20px;
        img{
          display: block;
          width: 100%;
          height: 100%;
        }
      }
      .proName{
        font-size: 28px;
        font-weight: 400;
        text-align: left;
        color: #030303;
        line-height: 40px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        margin-bottom: 24px;
      }
      .proDesc{
        width: 500px;
      }
      .proPriceWrap{
        display: flex;
        align-items:center;
        justify-content: space-between;
        .price{
          font-size: 32px;
          line-height: 38px;
          font-weight: 500;
          color: #E51515;
          margin-right: 8px;
          span{
            font-size: 24px;
          }
        }
        .stepWrap{
          display: flex;
          align-items:center;
          border: 2px solid #d8d8d8;
          border-radius: 22px;
          justify-content: flex-end;
          height: 44px;
          text-align:center;
          overflow: hidden;
          *{
            box-sizing:border-box;
          }
          .lessBtn{
            height: inherit;
            line-height: inherit;
            font-size: 20px;
            width: 48px;
            position: relative;
            background-color:#eeeeee;
            &.disabled{
              img{
                opacity: .3
              }
            }
            img{
              display: block;
              width: 20px;
              position:absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%,-50%);
            }
          }
          .addBtn{
            height: inherit;
            line-height: inherit;
            font-size: 20px;
            width: 48px;
            position: relative;
            background-color:#eeeeee;
            &.disabled{
              img{
                opacity: .3
              }
            }
            img{
              display: block;
              width: 20px;
              position:absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%,-50%);
            }
          }
          .proNum{
            width: 62px;
            height: 44px;;
            line-height: 44px;;
            font-size: 22px;
            color: #333333;
            font-weight: 400;
            border-left:2px solid #d8d8d8;
            border-right:2px solid #d8d8d8;
          }
        }
      }
    }
  }
  .waring{
    height: 48px;
    background: rgba(246,105,14,0.1);
    border-radius: 8px;
    display: flex;
    align-items:center;
    padding-left: 20px;
    box-sizing:border-box;
    font-size: 26px;
    font-weight: 400;
    text-align: left;
    color: #f6690e;
    line-height: 36px;
    margin-bottom: 28px;
    img{
      display: block;
      width: 32px;
      margin-right: 12px;

    }
  }
  .bzWrap{
    padding:0 24px;
    display: flex;
    span{
      width: 124px;
      color: #333333;
      font-size: 26px;
    }
    textarea{
      width: 578px;
      resize: none;
      height: 100px;
      border:none;
      font-size: 26px;
      &:focus{
        outline: none;
      }
    }
  }
  .fixedBtn{
    height: 108px;
    padding:16px 22px;
    display: flex;
    align-items:center;
    justify-content: flex-end;
    position:fixed;
    width: 100%;
    left: 0;
    bottom: 0;
    box-sizing:border-box;
    .totalText{
      color: #333333;
      line-height: 40px;
      font-size: 28px;
    }
    .price{
      font-size: 32px;
      line-height: 38px;
      font-weight: 500;
      color: #E51515;
      margin-right: 20px;
      span{
        font-size: 22px;
      }
    }
    .payBtn{
      width: 234px;
      height: 76px;
      line-height: 76px;
      text-align: center;
      background: linear-gradient(270deg,#fa865f, #eb263b);
      border-radius: 42px;
      font-size: 34px;
      color: #fff;
      font-weight: 400;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/activity/confirmOrder.vue